// Lib
import React, { Suspense, lazy, useCallback } from 'react';

// Components
import { LoadingState } from '@components/marble/States';
import ErrorBoundary from '@components/ErrorBoundary';
import { Button } from '@components/ui/button';

const AIDrawer = lazy(() => import('@components/AIDrawer/AIDrawerMain'));

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { OpenDrawer } from '@actions/drawer';

interface UseAIButtonReturn {
  openAIDrawer: (initialSessionId?: string) => void;
}

const useAIButton = (): UseAIButtonReturn => {
  const dispatch = useDispatch();

  const openAIDrawer = useCallback(
    (initialSessionId?: string): void => {
      dispatch(
        OpenDrawer({
          children: (
            <ErrorBoundary
              fallback={
                <div role="alert" className="space-y-3 p-6">
                  <p>AI chat could not load.</p>
                  <Button onClick={() => window.location.reload()}>
                    Reload
                  </Button>
                </div>
              }
            >
              <Suspense fallback={<LoadingState title="Opening AI chat…" />}>
                <AIDrawer initialSessionId={initialSessionId} />
              </Suspense>
            </ErrorBoundary>
          ),
          style: {
            padding: '0px',
            maxWidth: '536px',
          },
        }),
      );
    },
    [dispatch],
  );

  return { openAIDrawer };
};

export default useAIButton;
